import React, { useState, useEffect } from "react"

import styles from "./signup.module.scss"
import form from "./form.module.scss"

const TIME = 1.5 // Seconds

const Signup = ({ setModalIsOpen, setShowSuccess }) => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [validForm, setValidForm] = useState(false)

  const handleChange = e => {
    updateValues(e)
  }

  const updateValues = e => {
    const inputName = e.target.name
    const inputValue = e.target.value

    inputName === "name" ? setName(inputValue) : setEmail(inputValue)
  }

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  const handleSubmit = e => {
    e.preventDefault()
    const form = e.target

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        name: name,
        email: email,
      }),
    })
      .then(() => {
        setShowSuccess(true)
        setName("")
        setEmail("")

        setTimeout(() => {
          setShowSuccess(false)
          setModalIsOpen(false)
        }, TIME * 1000)
      })
      .catch(error => alert(error))
  }

  useEffect(() => {
    if (/\S+@\S+\.\S+/.test(email) && name.replace(/\s/g, "").length) {
      setValidForm(true)
    } else {
      setValidForm(false)
    }
  })

  return (
    <div className={styles.container}>
      <div className={`${styles.formContainer} formContainer`}>
        <form
          className={form.form}
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-recaptcha="true"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="contact" value="contact" />
          <div className={form.formFields}>
            <p>
              <input
                className={form.input}
                type="text"
                name="name"
                placeholder="Enter your name"
                value={name}
                required
                onChange={handleChange}
              />
            </p>
            <p>
              <input
                className={form.input}
                type="email"
                name="email"
                value={email}
                placeholder="Enter your email"
                required
                onChange={handleChange}
              />
            </p>
          </div>
          <div data-netlify-recaptcha="true" />
          <p>
            {validForm && (
              <button className={form.btn} type="submit">
                <span className={form.btnText}>Send</span>
              </button>
            )}
          </p>
        </form>
      </div>
    </div>
  )
}

export default Signup
